import React from 'react'

import CTA from '@f/elements/CTA'

const ListPagination = ({
  actions: { updateQuery },
  data: {
    apiResponse: { count = 0 },
    params
  }
}) => {
  if (count < 20) {
    return null
  }

  const handleClick = ({ event, direction = '', forcedPage = null }) => {
    event.preventDefault()
    event.stopPropagation()

    const currentOffset = params['offset'] ? parseInt(params['offset']) : 0

    if (direction === 'next') {
      params['offset'] = currentOffset + 20
    } else if (direction === 'previous') {
      params['offset'] = currentOffset >= 20 ? currentOffset - 20 : 0
    }

    if (forcedPage) {
      params['offset'] = (forcedPage - 1) * 20
    }

    updateQuery(params, { isPagination: true })
  }

  let page = params['offset'] ? parseInt(params['offset']) / 20 + 1 : 1
  let pageCount = Math.ceil(count / 20)

  let pages = []
  let startPaginationAt = page < 6 ? 1 : page - 1
  let endPaginationAt = page < 3 ? 4 : page + 2

  // If page count is exactly 2 there is no chance for a surrounding pagination
  // It's the one and only time we need to calc for ceil
  if (pageCount === 2) {
    endPaginationAt = 2
    pageCount = 2
  } else if (pageCount < 2) {
    return null
  }

  if (startPaginationAt !== 1) {
    pages.push(
      <li key='pagination-1' className='[ f-d-inbl f-p-a-010 f-m-a-005 ]'>
        <CTA
          className='[ f-t-body f-c-fo-neu400 ]'
          type='text-primary'
          onClick={event => handleClick({ event, forcedPage: 1 })}>
          1
        </CTA>
      </li>
    )
    pages.push(
      <li
        key='pagination-2'
        className='[ f-d-inbl f-p-a-010 f-m-a-005 f-t-body ]'>
        <CTA
          className='[ f-t-body f-c-fo-neu400 ]'
          type='text-primary'
          onClick={event => handleClick({ event, forcedPage: 2 })}>
          2
        </CTA>
      </li>
    )

    if (page + 2 === pageCount) {
      pages.push(
        <li
          key='pagination-3'
          className='[ f-d-inbl f-p-a-010 f-m-a-005 f-t-body ]'>
          <CTA
            className='[ f-t-body f-c-fo-neu400 ]'
            type='text-primary'
            onClick={event => handleClick({ event, forcedPage: 3 })}>
            3
          </CTA>
        </li>
      )
    }

    pages.push(
      <li
        className='[ f-d-inbl f-p-a-010 f-m-a-005 f-t-body ]'
        key='pagination-more-left'>
        ...
      </li>
    )
  }

  for (; startPaginationAt <= pageCount; startPaginationAt++) {
    let uniqueKey = `pagination-${startPaginationAt}`
    let pageLink = startPaginationAt * 1

    if (startPaginationAt === endPaginationAt) {
      if (startPaginationAt === page) {
        pages.push(
          <li
            key={uniqueKey}
            className='[ f-d-inbl f-p-a-010 f-m-a-005 f-t-body f-c-fo-neu400 ]'>
            {startPaginationAt}
          </li>
        )
      } else if (endPaginationAt === pageCount) {
        pages.push(
          <li
            className='[ f-d-inbl f-p-a-010 f-m-a-005 f-t-body ]'
            key={uniqueKey}>
            <CTA
              className='[ f-t-body f-c-fo-neu400 ]'
              type='text-primary'
              onClick={event => handleClick({ event, forcedPage: pageLink })}>
              {startPaginationAt}
            </CTA>
          </li>
        )
      } else {
        pages.push(
          <li
            className='[ f-d-inbl f-p-a-010 f-m-a-005 f-t-body f-c-fo-neu400 ]'
            key='pagination-more-right'>
            ...
          </li>
        )
      }
    } else if (startPaginationAt === page) {
      pages.push(
        <li
          key={uniqueKey}
          className='[ f-d-inbl f-p-a-010 f-m-a-005 f-t-body f-c-fo-neu400 ]'>
          {startPaginationAt}
        </li>
      )
    } else {
      if (
        !(startPaginationAt > endPaginationAt && startPaginationAt < pageCount)
      ) {
        pages.push(
          <li
            className='[ f-d-inbl f-p-a-010 f-m-a-005 f-t-body ]'
            key={uniqueKey}>
            <CTA
              type='text-primary'
              className='[ f-t-body f-c-fo-neu400 ]'
              onClick={event => handleClick({ event, forcedPage: pageLink })}>
              {startPaginationAt}
            </CTA>
          </li>
        )
      }
    }
  }

  return (
    <aside className='[ f-p-a-020 ]'>
      <nav className='[ f-d-flr ]'>
        <div style={page && page != 1 ? {} : { visibility: 'hidden' }}>
          <CTA
            type='block-secondary'
            className='[ f-p-h-020 ]'
            style={{ minWidth: 0 }}
            onClick={event =>
              page && page != 1
                ? handleClick({ event, direction: 'previous' })
                : () => {}
            }>
            Vorherige Seite
          </CTA>
        </div>

        <div className='[ f-hidden:m f-hidden:l f-fl-expand f-t-centre f-p-v-005 f-m-v-010 f-t-body ]'>
          {page}/{pageCount}
        </div>
        <ul className='[ f-!list f-hidden:s f-t-centre f-fl-expand ]'>
          {pages}
        </ul>

        <div style={page !== pageCount ? {} : { visibility: 'hidden' }}>
          <CTA
            type='block-secondary'
            className='[ f-p-h-020 ]'
            style={{ minWidth: 0 }}
            onClick={event =>
              page != pageCount
                ? handleClick({ event, direction: 'next' })
                : () => {}
            }>
            Nächste Seite
          </CTA>
        </div>
      </nav>
    </aside>
  )
}

export default ListPagination
